import React from 'react';
import styles from '../style/HomePage.module.css';

function ImprintPage() {
  return (
    <div className={styles.pageContainer} style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', color: 'var(--text-primary)' }}>
      <h1>Impressum</h1>

      <section style={{ marginTop: '2rem' }}>
        <h2>Angaben gemäß § 5 TMG</h2>
        <p>
          <strong>AWN GmbH</strong><br />
          Konrad-Zuse-Str. 1<br />
          84579 Unterneukirchen<br />
          Deutschland
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>Vertreten durch</h2>
        <p>
          Geschäftsführer: Richard Langlechner
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>Kontakt</h2>
        <p>
          Telefon: +49 (0) 8634 - 624 336<br />
          Fax: +49 (0) 8634 - 625 371<br />
          E-Mail: info@awn-gmbh.de
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>Registereintrag</h2>
        <p>
          Eintragung im Handelsregister.<br />
          Registergericht: Amtsgericht Traunstein<br />
          Registernummer: HRB 22358
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>Umsatzsteuer-ID</h2>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
          DE288084414
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>Streitschlichtung</h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer"> https://ec.europa.eu/consumers/odr</a>.<br />
          Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>Haftungsausschluss (Disclaimer)</h2>
        <h3>Haftung für Inhalte</h3>
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. 
          Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen 
          zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>
      </section>
    </div>
  );
}

export default ImprintPage;